import { obterParametrosDaURL } from "../../../../functions";
import { ICabecalhoPrevisaoCompra, IItemPrevisaoCompra, ISolicitacaoSenhaExcedentes } from "../../../../interfaces";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

interface IRetornoGetInformacoesByCod {
  nLarPrevisaoCompraDTO: ICabecalhoPrevisaoCompra;
  nLarPrevisaoCompraItem: IItemPrevisaoCompra[];
  solicitacaoSenhaExcedentes: ISolicitacaoSenhaExcedentes[];
}

interface IParametrosPrevisaoCompra {
  codPrevisao: number;
  sequencial: number;
  codLoja: number;
  currentPage: number;
  limit: number;
}

export const ObterInformacoesPeloCodigo = async (
  params: IParametrosPrevisaoCompra
): Promise<IRetornoGetInformacoesByCod> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IRetornoGetInformacoesByCod>(
      `/previsaocompraporid/${params.codPrevisao}/${params.sequencial}/${params.codLoja}`,
      { params: { token, ...params } }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Erro ao buscar informações da previsão de compra."
    );
  }
};